var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shown)?_c('div',[_c('div',{attrs:{"id":"install_banner"}},[_c('v-container',[_c('v-row',{staticStyle:{"align-items":"center"}},[_c('span',[_vm._v("Install eReader to home screen?")]),_c('v-spacer'),_c('button',{on:{"click":_vm.installPWA}},[_vm._v("Yes")]),_c('button',{on:{"click":_vm.dismissPrompt}},[_vm._v("No")])],1)],1)],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }